const PbxxRecord = require('../pbxx_record')
const cloudinary = require('cloudinary-core').Cloudinary.new().init()

module.exports = class DigitalAsset extends PbxxRecord {
  static get class_name() {
    return 'DigitalAsset'
  }

  get has_file() {
    return !!this.file
  }

  get is_image() {
    return this.has_file && this.file.resource_type === 'image'
  }

  get is_video() {
    return this.has_file && this.file.resource_type === 'video'
  }

  get is_external_video() {
    return !!this.external_video_url
  }

  get is_gif() {
    return this.has_file && this.file.resource_type === 'image' && this.file.format === 'gif'
  }

  get is_pdf() {
    return this.has_file && this.file.resource_type === 'image' && this.file.format === 'pdf'
  }

  get is_zip() {
    return this.has_file && this.file.resource_type === 'raw'
  }

  get youtube_id() {
    return !!this.external_video_url
      ? extract_youtube_id(this.external_video_url)
      : null
  }

  get responsive_image_url() {
    if (this.is_image) {
      return cloudinary.url(this.file.public_id, {
        width: 'auto',
        dpr: 'auto',
        fetch_format: 'auto',
        quality: 'auto',
        responsive: 'true',
        crop: 'fill',
        responsive_placeholder: 'blank'
      })
    }
  }

  get constrained_responsive_image_url() {
    if (this.is_image) {
      return cloudinary.url(this.file.public_id, {
        width: 'auto',
        dpr: 'auto',
        fetch_format: 'auto',
        quality: 'auto',
        responsive: 'true',
        aspect_ratio: '16:9',
        crop: 'fill',
        responsive_placeholder: 'blank'
      })
    }
  }

  get image_url_thumb() {
    let public_id
    let transformations = {
      width: 50,
      dpr: 'auto',
      fetch_format: 'auto',
      quality: 'auto',
      responsive: 'true',
      crop: 'fill',
      responsive_placeholder: 'blank'
    }
    if (this.is_external_video) {
      transformations.type = this.source
      public_id = this.external_video_id
    } else if (this.has_file) {
      public_id = this.file.public_id
    }

    let url = cloudinary.url(public_id, transformations)
    return this.is_video
      ? url.replace('image', 'video')
      : url
  }

  get video_tag() {
    if (!this.is_video) {
      return null
    }
    return cloudinary.video(this.file.public_id, {
      video_codec: 'auto',
      controls: true,
      width: 500,
      style: 'width: 100%;'
    })
  }

  get image_eligible() {
    if (this.file.width && this.file.height) {
      if (this.file.width >= 600 && this.file.height >= 315) return true
    }
    return false
  }
}

function extract_youtube_id(url) {
  let id = ''
  url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
  if (url[2] !== undefined) {
    id = url[2].split(/[^0-9a-z_\-]/i)
    id = id[0]
  }
  else {
    id = url
  }
  return id
}
